import { render, staticRenderFns } from "./EducationFormResume.vue?vue&type=template&id=63da372b"
import script from "./EducationFormResume.vue?vue&type=script&lang=ts"
export * from "./EducationFormResume.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63da372b')) {
      api.createRecord('63da372b', component.options)
    } else {
      api.reload('63da372b', component.options)
    }
    module.hot.accept("./EducationFormResume.vue?vue&type=template&id=63da372b", function () {
      api.rerender('63da372b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/profile/educations/EducationFormResume.vue"
export default component.exports